import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class LdapServerApi extends CollectionApi {
  constructor() {
    super('/api/v2/ldapservers', {
      skip: 0,
      limit: 100,
      sort: 'name', // Prepend with a '-' to reverse default sort direction
      filter: [{
        name: 'name',
        operator: 'search',
        value: '',
      }],
    });
  }

  createSambaDomain = (ldapServerId, sambaDomain) => {
    const url = `/api/v2/ldapservers/${ldapServerId}/sambadomains`;
    return axios.post(url, sambaDomain);
  }

  updateSambaDomain = (ldapServerId, sambaDomain) => {
    const url = `/api/v2/ldapservers/${ldapServerId}/sambadomains/${sambaDomain.id}`;
    return axios.put(url, sambaDomain);
  }

  deleteSambaDomain = (ldapServerId, sambaDomain) => {
    const url = `/api/v2/ldapservers/${ldapServerId}/sambadomains/${sambaDomain.id}`;
    return axios.delete(url, sambaDomain);
  }

  getAssociations(ldapServerId) {
    return this.getAllItems(`/api/v2/ldapservers/${ldapServerId}/associations?targets=user`);
  }

  getBoundUserGroupCount(ldapServerId) {
    return this.fetchTotalCount(`/api/v2/ldapservers/${ldapServerId}/usergroups`);
  }

  getBoundUserCount(ldapServerId) {
    return this.fetchTotalCount(`/api/v2/ldapservers/${ldapServerId}/users`);
  }

  getSambaDomainCount(ldapServerId) {
    return this.fetchTotalCount(`/api/v2/ldapservers/${ldapServerId}/sambadomains`);
  }

  getSambaDomains(ldapServerId) {
    return this.getAllItems(`/api/v2/ldapservers/${ldapServerId}/sambadomains`);
  }
}

window.LdapServerApi = new LdapServerApi();

export default new LdapServerApi();
